module.exports = __webpack_public_path__ + "static/icons/icon-map--usa-c0fcdc64c767aae7cb6ddfba52c5d3e5.svg";